import { UtensilsCrossed, CalendarCheck, Phone, MapPin } from "lucide-react";
import { scrollToSection } from "../../lib/api";
import { RESTAURANT_PHONE_TEL } from "../../lib/config";

export function MobileDock({ settings }) {
  const mapsHref = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(settings?.maps_query || "Red Stone Ceccano")}`;

  const itemCls = "flex flex-col items-center gap-1 py-1 text-[9px] font-bold uppercase tracking-[0.18em] text-cream-muted";

  return (
    <nav data-testid="mobile-sticky-dock" className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-obsidian/95 backdrop-blur-xl border-t border-white/10 px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
      <div className="grid grid-cols-4">
        <button data-testid="mobile-dock-menu-btn" onClick={() => scrollToSection("#menu")} className={itemCls}>
          <UtensilsCrossed className="w-5 h-5" /> Menu
        </button>
        <button data-testid="mobile-dock-prenota-btn" onClick={() => scrollToSection("#prenota")} className="flex flex-col items-center gap-1 py-1 text-[9px] font-bold uppercase tracking-[0.18em] text-gold-glow">
          <span className="bg-burgundy-brand rounded-full p-1.5 border border-gold/40">
            <CalendarCheck className="w-5 h-5 text-cream" />
          </span>
          Prenota
        </button>
        <a data-testid="mobile-dock-chiama-btn" href={`tel:${RESTAURANT_PHONE_TEL}`} className={itemCls}>
          <Phone className="w-5 h-5" /> Chiama
        </a>
        <a data-testid="mobile-dock-mappa-btn" href={mapsHref} target="_blank" rel="noopener noreferrer" className={itemCls}>
          <MapPin className="w-5 h-5" /> Mappa
        </a>
      </div>
    </nav>
  );
}
